import React from 'react';
import { BRAND_LOGO_URL } from '../../constants/brandAssets';

const DOT_COUNT = 8;

export default function Loader() {
    return (
        <div
            className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white"
            role="status"
            aria-busy="true"
            aria-live="polite"
            aria-label="Loading"
        >
            <img
                src={BRAND_LOGO_URL}
                alt=""
                width={250}
                height={250}
                className="h-[250px] w-[250px] max-h-[min(250px,45vh)] max-w-[min(250px,calc(100vw-2rem))] shrink-0 object-contain select-none"
                draggable={false}
            />

            <div className="relative mt-10 h-14 w-14 shrink-0 sm:h-16 sm:w-16">
                <div className="absolute inset-0 animate-dz-splash-spin motion-reduce:animate-none">
                    {Array.from({ length: DOT_COUNT }).map((_, i) => (
                        <div
                            key={i}
                            className="absolute inset-0"
                            style={{ transform: `rotate(${(360 / DOT_COUNT) * i}deg)` }}
                        >
                            <span
                                className="absolute left-1/2 top-1.5 block h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-blue-600 shadow-sm animate-dz-splash-dot motion-reduce:scale-90 motion-reduce:animate-none motion-reduce:opacity-80 sm:h-3 sm:w-3 sm:top-2"
                                style={{ animationDelay: `${i * 0.11}s` }}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
